// Module
var code = "<a class=\"social-user-avatar social-avatar\" ng-style=\"::{'background-image':'url(' + profilePhotoUrl + '), url(' + avaDefaultImage + ')'}\" ng-href=\"{{::href}}\" target=\"{{::target}}\"></a> ";
// Exports
module.exports = code;